var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgO1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.54 25.42C11.2987 25.42 10.1787 25.1307 9.18 24.552C8.19067 23.9733 7.40667 23.1893 6.828 22.2C6.24933 21.2013 5.96 20.0813 5.96 18.84V11C5.96 9.75867 6.24933 8.64333 6.828 7.654C7.40667 6.65533 8.19067 5.86667 9.18 5.288C10.1787 4.70933 11.2987 4.42 12.54 4.42C13.7813 4.42 14.8967 4.70933 15.886 5.288C16.8847 5.86667 17.6733 6.65533 18.252 7.654C18.8307 8.64333 19.12 9.75867 19.12 11V18.84C19.12 20.0813 18.8307 21.2013 18.252 22.2C17.6733 23.1893 16.8847 23.9733 15.886 24.552C14.8967 25.1307 13.7813 25.42 12.54 25.42ZM12.54 23.432C13.3707 23.432 14.1267 23.2313 14.808 22.83C15.4893 22.4193 16.0307 21.8733 16.432 21.192C16.8333 20.5107 17.034 19.7593 17.034 18.938V10.902C17.034 10.0713 16.8333 9.31533 16.432 8.634C16.0307 7.95267 15.4893 7.41133 14.808 7.01C14.1267 6.59933 13.3707 6.394 12.54 6.394C11.7093 6.394 10.9533 6.59933 10.272 7.01C9.59067 7.41133 9.04933 7.95267 8.648 8.634C8.24667 9.31533 8.046 10.0713 8.046 10.902V18.938C8.046 19.7593 8.24667 20.5107 8.648 21.192C9.04933 21.8733 9.59067 22.4193 10.272 22.83C10.9533 23.2313 11.7093 23.432 12.54 23.432Z",
    fill: "#6F5E7E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2.41422,
    width: 2,
    height: 35,
    transform: "rotate(-45 0 2.41422)",
    fill: "#6F5E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO1);
export default __webpack_public_path__ + "static/media/o1.3decb12398ad57436a7f5980a9e8386c.svg";
export { ForwardRef as ReactComponent };